<template>
	<picture class="ti" v-scroll="appearOnScroll">
		<div class="w" v-show="imgSrc.indexOf('Yaroslav') !== -1">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
				<circle cx="50%" cy="50%" r="50%" :fill="$const.COLOR.DARK"/>
				<polygon points="0,50 50,100 0,100" :fill="$const.COLOR.DARK"/>
			</svg>
			<rr-text :text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_SECONDARY_SMALL"
			         :text-color="$const.HTML_CLASS.TEXT_COLOR.APP_PRIMARY">Common,<br>
				{{ $store.getters.isMobileGridBreakpoint ? 'Click' : 'Hover' }} me!</rr-text>
		</div>
	</picture>
</template>

<script>
// import {TimelineLite} from 'gsap/all'
import scrollAnimation from '../rr/mixins/scroll-animation'
import * as THREE from 'three'
import imgDispSrc from '@/assets/img/8.jpg'
import {TweenLite, Expo} from 'gsap/all'

export default {
	name: 'TeamImage',
	mixins: [
		scrollAnimation,
		// debugAnimation,
	],
	data() {
		return {
			// hoverInterval: null
		}
	},
	props: {
		imgSrc: {
			type: String,
			required: true,
		},
		imgHoverSrc: {
			type: String,
			required: true,
		},
	},
	computed: {},
	methods: {
		// render
		renderScene() {
			const vertex = `
        varying vec2 vUv;
        void main() {
          vUv = uv;
          gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
        }
    `

			const fragment = `
        varying vec2 vUv;

        uniform sampler2D texture;
        uniform sampler2D texture2;
        uniform sampler2D disp;

        // uniform float time;
        // uniform float _rot;
        uniform float dispFactor;
        uniform float effectFactor;

        // vec2 rotate(vec2 v, float a) {
        //  float s = sin(a);
        //  float c = cos(a);
        //  mat2 m = mat2(c, -s, s, c);
        //  return m * v;
        // }

        void main() {

            vec2 uv = vUv;

            // uv -= 0.5;
            // vec2 rotUV = rotate(uv, _rot);
            // uv += 0.5;

            vec4 disp = texture2D(disp, uv);

            vec2 distortedPosition = vec2(uv.x + dispFactor * (disp.r*effectFactor), uv.y);
            vec2 distortedPosition2 = vec2(uv.x - (1.0 - dispFactor) * (disp.r*effectFactor), uv.y);

            vec4 _texture = texture2D(texture, distortedPosition);
            vec4 _texture2 = texture2D(texture2, distortedPosition2);

            vec4 finalTexture = mix(_texture, _texture2, dispFactor);

            gl_FragColor = finalTexture;
            // gl_FragColor = disp;
        }
    `

			const parent = this.$el
			const dispImage = imgDispSrc
			const image1 = this.imgSrc
			const image2 = this.imgHoverSrc
			const intensity = -0.65
			const speedIn = 1.2
			const speedOut = 1.2
			const easing = Expo.easeOut

			const offsetHeight = parent.offsetWidth * (600 / 447)

			const scene = new THREE.Scene()
			const camera = new THREE.OrthographicCamera(
				parent.offsetWidth / -2,
				parent.offsetWidth / 2,
				offsetHeight / 2,
				offsetHeight / -2,
				1,
				1000,
			)

			camera.position.z = 1

			const renderer = new THREE.WebGLRenderer({
				antialias: false,
				// alpha: true
			})

			renderer.setPixelRatio(window.devicePixelRatio)
			renderer.setClearColor(0xffffff, 0.0)
			renderer.setSize(parent.offsetWidth, offsetHeight)
			parent.appendChild(renderer.domElement)

			// const addToGPU = function(t) {
			//     renderer.setTexture2D(t, 0);
			// };

			const loader = new THREE.TextureLoader()
			loader.crossOrigin = ""
			const texture1 = loader.load(image1)
			const texture2 = loader.load(image2)

			const disp = loader.load(dispImage)
			disp.wrapS = disp.wrapT = THREE.RepeatWrapping

			texture1.magFilter = texture2.magFilter = THREE.LinearFilter
			texture1.minFilter = texture2.minFilter = THREE.LinearFilter

			texture1.anisotropy = renderer.capabilities.getMaxAnisotropy()
			texture2.anisotropy = renderer.capabilities.getMaxAnisotropy()

			const mat = new THREE.ShaderMaterial({
				uniforms: {
					effectFactor: {type: "f", value: intensity},
					dispFactor: {type: "f", value: 0.0},
					texture: {type: "t", value: texture1},
					texture2: {type: "t", value: texture2},
					disp: {type: "t", value: disp},
				},

				vertexShader: vertex,
				fragmentShader: fragment,
				transparent: true,
				opacity: 1.0,
			})

			const geometry = new THREE.PlaneBufferGeometry(
				parent.offsetWidth,
				offsetHeight,
				1,
			)
			const object = new THREE.Mesh(geometry, mat)
			scene.add(object)

			const w = this.$el.querySelector('.w')

			const addEvents = function () {
				parent.addEventListener('mouseenter', function () {
					TweenLite.to(mat.uniforms.dispFactor, speedIn, {
						value: 1,
						ease: easing,
					})
					w.style.display = 'none'
				})

				parent.addEventListener('mouseleave', function () {
					TweenLite.to(mat.uniforms.dispFactor, speedOut, {
						value: 0,
						ease: easing,
					})
				})

				parent.addEventListener('touchstart', function () {
					TweenLite.to(mat.uniforms.dispFactor, speedIn, {
						value: 1,
						ease: easing,
					})
				})

				parent.addEventListener('touchend', function () {
					TweenLite.to(mat.uniforms.dispFactor, speedOut, {
						value: 0,
						ease: easing,
					})
				})
			}

			addEvents()

			window.addEventListener("resize", function () {
				renderer.setSize(parent.offsetWidth, parent.offsetWidth * (600 / 447))
			})

			const animate = function () {
				requestAnimationFrame(animate)

				renderer.render(scene, camera)
			}
			animate()
		},
		buildScrollTl() {
			// render scene
			this.renderScene()

			// start label
			this.scrollTl.add('s')

			// constiables
			const i = this.$el.querySelector('canvas')

			// image (scale + fade)
			this.scrollTl.fromTo(i, .83, {
				scale: 1.04,
			}, {
				scale: 1,
				ease: 'is',
			})
			this.scrollTl.fromTo(i, .83, {
				opacity: 0,
			}, {
				opacity: 1,
				ease: 'is',
			}, 's+=.067')

			// image mask (scale from top)
			const cpFrom = 'inset(0% 0% 100%)',
				cpTo = 'inset(0% 0% 0%)'

			this.scrollTl.fromTo(this.$el, .83, {
				webkitClipPath: cpFrom,
				clipPath: cpFrom,
				// transformOrigin: 'center',
				// z: 10,
				// force3D: true,
			}, {
				webkitClipPath: cpTo,
				clipPath: cpTo,
				ease: 'is',
			}, 's')

			this.scrollTl.fromTo(this.$el.querySelector('div'), .67, {
				scale: 0,
				transformOrigin: 'left bottom',
				// z: 10,
				// force3D: true,
			}, {
				scale: 1,
				transformOrigin: 'left bottom',
				ease: 'ease',
			}, 's')
		},
	},
	mounted() {
		// this.hoverInterval = setInterval(() => {
		// 	if (Math.random() > .5) {
		//
		// 	}
		// }, 10000*Math.random())
	},
	destroyed() {
		// clearInterval(this.hoverInterval)
	}
}
</script>

<style lang="scss">
.ti {
	display: block;
	background-color: var(--light-gray);
	position: relative;
	.w {
		position: absolute;
		@include sizing-responsive-width-screen-x(100);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 10;
		top: 10%;
		right: 10%;
		svg {
			display: block;
			width: 100%;
		}
		p {
			position: absolute;
		}
		@include breakpoint($mobileDesignBreakpoint) {
			width: 90px;
			right: 5%;
		}
	}
}
</style>
